/*
  OFFE - collection filter drawer helpers (Oct 27, 2026). Goes with
  assets/custom-filter-drawer.css; both loaded by the grid_fill section in
  templates/collection.json.
  - Marks the Size group (offe-facet--size) so its values show as boxes.
  - Shows how many values are picked next to each group name.
  - "Show items (139)" reads "View 139 items" (Figma).
  - Search box at the top of the Brand group.
  - Hides sizes that are only left in sold-out products: it asks the store
    for the same page with "In stock" ticked and hides the sizes that come
    back empty there. Skipped when the shopper has picked In stock (the
    theme already hides empty values then) or Out of stock.
*/
(function () {
  var AV = 'filter.v.availability';
  var cache = {};

  function groupTitle(d) {
    var t = d.querySelector('.facets__summary-title');
    return t ? (t.childNodes[0] && t.childNodes[0].textContent || t.textContent).trim() : '';
  }


  // Brand group: a search box above the list (Rachel, Oct 27). The query is
  // kept across filter re-renders.
  var brandQ = '';
  function brandSearch(d) {
    var list = d.querySelector('.facets__list') || d.querySelector('ul');
    if (!list) return;
    var box = d.querySelector('.offe-facet-search');
    if (!box) {
      box = document.createElement('div');
      box.className = 'offe-facet-search';
      box.innerHTML = '<input type="search" placeholder="Search brands" aria-label="Search brands" autocomplete="off"><p class="offe-facet-search__none" hidden>No brands match</p>';
      list.parentNode.insertBefore(box, list);
      var inp = box.querySelector('input');
      inp.value = brandQ;
      inp.addEventListener('input', function () { brandQ = inp.value; filterBrands(d); });
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
      ['change', 'input'].forEach(function (ev) { box.addEventListener(ev, function (e) { e.stopPropagation(); }); });
    }
    filterBrands(d);
  }
  function filterBrands(d) {
    var q = brandQ.trim().toLowerCase();
    var shown = 0;
    d.querySelectorAll('.facets__item').forEach(function (li) {
      var lab = li.querySelector('.facet-checkbox__label') || li;
      var hit = !q || lab.textContent.toLowerCase().indexOf(q) >= 0;
      li.classList.toggle('offe-search-miss', !hit);
      if (hit && !li.querySelector('input:disabled')) shown++;
    });
    var none = d.querySelector('.offe-facet-search__none');
    if (none) none.hidden = !(q && !shown);
  }

  function decorate() {
    var wrap = document.querySelector('.facets__wrapper');
    if (!wrap) return;
    wrap.querySelectorAll('details.js-filter').forEach(function (d) {
      var title = groupTitle(d);
      d.classList.toggle('offe-facet--size', /size/i.test(title));
      if (/brand|vendor|designer/i.test(title)) brandSearch(d);
      var summaryTitle = d.querySelector('.facets__summary-title');
      var n = d.querySelectorAll('.facets__item > input:checked').length;
      var badge = summaryTitle && summaryTitle.querySelector('.offe-facet-count');
      if (n && summaryTitle) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'offe-facet-count';
          var caret = summaryTitle.querySelector('svg');
          summaryTitle.insertBefore(badge, caret || null);
        }
        if (badge.textContent !== '(' + n + ')') badge.textContent = '(' + n + ')';
      } else if (badge) {
        badge.remove();
      }
    });
    var btn = wrap.querySelector('.fascets__show-items .button__label');
    if (btn && !btn.hasAttribute('data-offe')) {
      var m = btn.textContent.match(/\((\d[\d,]*)\)/);
      var count = m ? m[1] : '';
      if (!count) {
        var prog = document.querySelector('.load-more-wrapper__progress-label');
        var pm = prog && prog.textContent.match(/of\s+([\d,]+)/i);
        if (pm) count = pm[1];
      }
      btn.textContent = count ? 'View ' + count + ' items' : 'View items';
      btn.setAttribute('data-offe', '1');
    }
  }

  function hideSoldOutSizes() {
    var wrap = document.querySelector('.facets__wrapper');
    var grid = document.getElementById('product-grid');
    if (!wrap || !grid) return;
    var sizeGroup = wrap.querySelector('details.offe-facet--size');
    if (!sizeGroup) return;
    var params = new URLSearchParams(location.search);
    if (params.getAll(AV).length) return; // In stock / Out of stock picked: leave as is
    params.append(AV, '1');
    params.delete('page');
    params.set('section_id', grid.getAttribute('data-id'));
    var key = params.toString();
    var apply = function (empty) {
      sizeGroup.querySelectorAll('.facets__item').forEach(function (li) {
        var input = li.querySelector('input');
        if (!input) return;
        li.classList.toggle('offe-sold-out-size', !input.checked && empty.indexOf(input.value) >= 0);
      });
    };
    if (cache[key]) { apply(cache[key]); return; }
    cache[key] = [];
    fetch(location.pathname + '?' + key, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var empty = [];
        doc.querySelectorAll('details.js-filter').forEach(function (d) {
          if (!/size/i.test(groupTitle(d))) return;
          d.querySelectorAll('.facets__item > input').forEach(function (inp) {
            if (inp.disabled) empty.push(inp.value);
          });
        });
        cache[key] = empty;
        var live = document.querySelector('.facets__wrapper details.offe-facet--size');
        if (live) { sizeGroup = live; apply(empty); }
      })
      .catch(function () { delete cache[key]; });
  }

  function run() { decorate(); hideSoldOutSizes(); }

  function start() {
    if (!document.body.classList.contains('template-collection')) return;
    run();
    var t;
    new MutationObserver(function () {
      clearTimeout(t); t = setTimeout(run, 60);
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();